// extracted by mini-css-extract-plugin
export default {"container":"TrHZIaf","link":"iTjRHo2","image":"A1ue5Ti","label":"YIlbo_w XKvcAqM london4","label__sale":"wgGh4O6"};